
import { EventAdsBuildingUnitView } from "./event-ads-building-unit-view";

export class EventAdsBuildingUnitAdd {
  companyId: number;
  buildingId: number;
  levelId: number;
  buildingUnits: EventAdsBuildingUnitView[];
}




// WEBPACK FOOTER //
// ./src/app/core/models/event-ads-building-unit-add.ts